import React from 'react';
import { Dialog, Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface GstDocumentViewerModalProps {
  open: boolean;
  onClose: () => void;
  documentUrl: string | null;
  isPdf?: boolean;
}

const styles = {
  paper: {
    bgcolor: '#1a1a1a',
    margin: 0,
    maxHeight: '100vh',
    maxWidth: '100vw',
  },
  root: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    bgcolor: '#1a1a1a',
    display: 'flex',
    flexDirection: 'column',
  },
  backButton: {
    position: 'absolute',
    top: 16,
    left: 16,
    width: 40,
    height: 40,
    bgcolor: '#fafafa',
    border: '0.672px solid rgba(0,0,0,0.23)',
    zIndex: 10,
    '&:hover': {
      bgcolor: '#f0f0f0',
    },
  },
  backIcon: {
    color: 'rgba(0,0,0,0.87)',
    fontSize: 22,
  },
  documentContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'auto',
    padding: '72px 16px 16px',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain' as const,
    borderRadius: '4px',
    backgroundColor: '#fff',
  },
  iframe: {
    width: '100%',
    height: '65%',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#fff',
    display: 'block',
    margin: 'auto',
  },
};

export function GstDocumentViewerModal({ open, onClose, documentUrl, isPdf }: GstDocumentViewerModalProps) {
  return (
    <Dialog
      open={open && Boolean(documentUrl)}
      onClose={onClose}
      fullScreen
      PaperProps={{ sx: styles.paper }}
      TransitionProps={{ unmountOnExit: true }}
    >
      <Box sx={styles.root}>
        <IconButton onClick={onClose} sx={styles.backButton}>
          <ArrowBackIcon sx={styles.backIcon} />
        </IconButton>

        <Box sx={styles.documentContainer}>
          {documentUrl && (isPdf ? (
            <embed
              src={`${documentUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              type="application/pdf"
              title="GST Certificate"
              style={styles.iframe}
            />
          ) : (
            <img
              src={documentUrl}
              alt="GST Certificate"
              style={styles.image}
            />
          ))}
        </Box>
      </Box>
    </Dialog>
  );
}
